import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux";
import { useLocation, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Utils from "../../Utility";

// actions
import AddCard from "../../Forms/AddCommunity";
import Table from "./Table";
import Loader from "../../../components/Loader";
import {
  AvCheckbox,
  AvCheckboxGroup,
  AvField,
  AvForm,
} from "availity-reactstrap-validation";
import { get, post, put, upload } from "../../../helpers/api_helper";
import { toast } from "react-toastify";
// import CompSingle from './compSingle';

const Property = (props) => {
  const { user } = props;
  const location = useLocation()
  const [isAddForm, setIsAddForm] = useState(false);
  const [isTable, setIsTable] = useState(true);
  const [currentData, setCurrentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [singleId, setSingleId] = useState(null);
  const [file, setFile] = useState(null);
  const [data, setData] = useState(undefined)
  const [id, setId] = useState();
  const imageInput = useRef();
  const formRef = useRef();

  const onChangeFile = (event) => {
    // Handle file change logic here
    console.log("File changed:", event.target.files);
  };

  useEffect(() => {
    if (location?.state?.state?.data) {
      setCurrentData(location?.state?.state?.data);
    } else {
      setCurrentData(null);
      setFile(null);
    }
  }, [location?.state]);

  useEffect(() => {
    if (user) {
      getData();
    }
  }, [user]);

  const getData = () => {
    get("/category", { token: user?.token })
      .then((json) => {
        // console.log('response from get project list', json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
      })
      .catch((error) => {
        console.log("error while getting project list", error);
      });
  };
  console.log(file)
  const handleValidSubmit = async (e, v) => {
    console.log("values", v);
    let body = {
      ...v,
      fileInput: undefined,
      token: user?.token,
    };
    if (file) {
      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
      if (isPdf) {
        setLoading(true);
        const formData = new FormData();
        formData.append("pdf", file);
        const recept = await upload("/pdf/upload", formData);
        if (recept?.statusCode === 200) {
          body.pdf = recept?.data || recept?.url;
        } else {
          toast.error(recept?.message || "Failed to upload PDF file");
          setLoading(false);
          return;
        }
      } else {
        toast.error("Only PDF files are allowed!");
        return;
      }
    } else if (currentData?.pdf) {
      body.pdf = currentData.pdf;
    }
    if (currentData) {
      body = { ...body, pdfMasterId: currentData?._id, };
      put("/pdf", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message || "Updated successfully");
            console.log("res from tender", res);
            setFile(null);
            setCurrentData(null);
            if (imageInput.current) imageInput.current.value = "";
            if (formRef.current) formRef.current.reset();
            props.history.push("/view-pdf");
          } else {
            toast.error(res?.error || "Update failed");
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    } else {
      post("/pdf", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message || "Added successfully");
            console.log("res from tender", res);
            setFile(null);
            setCurrentData(null);
            if (imageInput.current) imageInput.current.value = "";
            if (formRef.current) formRef.current.reset();
            props.history.push("/view-pdf");
          } else {
            toast.error(res?.error || "Failed to add PDF");
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }

  };

  console.log('currentData', currentData)

  return (
    <React.Fragment>
      {/* <MetaTags>
        <meta name="description" content="Helmet application" />
      </MetaTags> */}
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb
          title={Utils.projectName}
          breadcrumbItem={currentData ? `Add Job!` : `Add PDF`}
        />
        <div
          className="p-2 main-box-form"
          style={{ marginLeft: "80px", marginRight: "80px" }}
        >
          <AvForm
            ref={formRef}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v, "bank");
            }}
          >
            <Row>
              <Col lg={12} md={12}>
                <div className="mb-3">
                  <AvField
                    name="fileInput"
                    label="PDF File"
                    className="form-control"
                    placeholder="Upload PDF"
                    type="file"
                    onChange={(e) => setFile(e.target.files[0])}
                    // required
                    multiple={false}
                    ref={imageInput}
                    accept=".pdf"
                  // value={currentData?.pdf}
                  />
                  <span>{file ? file?.name : currentData?.pdf}</span>
                </div>
              </Col>
              <Col lg={12} md={12}>
                <div className="mb-3">
                  <AvField
                    name="catId"
                    label="Select Category *"
                    className="form-control"
                    placeholder="Enter live session url"
                    type="select"
                    required
                    value={currentData?.catId}
                  >
                    <option value="">Select Category</option>
                    {
                      data?.map((item, index) => {
                        return (
                          <option key={index} value={item?._id}>{item?.title}</option>
                        )
                      })
                    }

                  </AvField>
                </div>
              </Col>

              <Col lg={12} md={12}>
                <div className="mb-3">
                  <AvField
                    name="title"
                    label="Title *"
                    className="form-control"
                    placeholder="Example :Sealed tenders are invited for supply....."
                    type="text"
                    required
                    value={currentData?.title}
                  />
                </div>
              </Col>

              <br />

            </Row>
            <div className="mt-4">
              <Row>
                <Col md={6}>
                  <button
                    className="btn btn-primary w-100 waves-effect waves-light"
                    style={{
                      backgroundColor: Utils.themeColor,
                      border: "none",
                    }}
                    onClick={() => {
                      props.history.push("/view-pdf");
                    }}
                    type="button"
                  >
                    Cancel
                  </button>
                </Col>
                <Col md={6}>
                  <button
                    className="btn btn-primary w-100 waves-effect waves-light"
                    type="submit"
                    style={{
                      backgroundColor: Utils.themeColor,
                      border: "none",
                    }}
                  >
                    {currentData ? "Update" : "Add"}
                  </button>
                </Col>
              </Row>
            </div>
          </AvForm>
        </div>
      </div>
    </React.Fragment>
  );
};

Property.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { user } = state.Profile;
  const { company } = state.Company;
  return { user, company };
};

export default withRouter(connect(mapStatetoProps, {})(Property));
